import { createAsyncThunk } from '@reduxjs/toolkit';
import { _hospitalUrls } from '@custom/Utils/constants/apiUrls';

const hospitalDetailApi = createAsyncThunk('hospitalDetails', async ({ hospitalId }: { hospitalId: string }) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_hospitalUrls.getDetails}?hospitalId=${hospitalId}`
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default hospitalDetailApi;
